import { render, staticRenderFns } from "./TrialBtn.vue?vue&type=template&id=3c0f0467&"
import script from "./TrialBtn.vue?vue&type=script&lang=ts&"
export * from "./TrialBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports